import React, { useContext, useState } from "react";
import { PositionedItemsContainer } from './PositionedItemsContainer';
import { DesktopFileView } from './DesktopFileView';
import { DesktopRightMenu } from './DesktopRightMenu';
import { AppContext } from "../../../../appContext";
import './Desktop.css';
import { getWallpaperByKey, getColorByWallpaper, getShadowColorByWallpaper } from "../../../../utils/wallpapers";

const DesktopLegacyFileView = ({files}: {files: Array<string>})=>{
    <div className="desktop_files">
        {files.map(it=><div className="desktop_file">
            <div className="desktop_file_icon">

            </div>
            <div className="desktop_file_name">
                {it}
            </div>
        </div>)}
    </div>
}

interface IDesktopProps{
}

export const Desktop = ({}: IDesktopProps)=>{
    const { cheat } = useContext(AppContext);
    const {wallpaper, setWallpaper} = useContext(AppContext);
    return <div className={`desktop`} style={wallpaper !='' ? {'--fileNameColor': getColorByWallpaper(wallpaper), '--fileNameShadowColor': getShadowColorByWallpaper(wallpaper)} as any : {}}>
        <div className="desktop_back" style={wallpaper != '' ? {backgroundImage: `url(${getWallpaperByKey(wallpaper)})`} : {}}>
        
        </div>
        {wallpaper == '' && <div className="desktop_back_shade">
        
        </div>}
        <div className="desktop_content">
            <DesktopFileView></DesktopFileView>
            {cheat.debug && <DesktopRightMenu></DesktopRightMenu>}
        </div>
    </div>
}